import { RGBAColor } from "core/math";
import { IsIOSMTags } from "./osm.interfaces";
import { OSMTagSet } from "./osm.tagset";
import { ColorResolver } from "./osm.colorResolver";
export class ForestColors {
}
ForestColors.DefaultColor = RGBAColor.darkgreen;
ForestColors.ColorMap = new Map([
    ["deciduous", "forestgreen"],
    ["evergreen", "darkgreen"],
    ["broadleaved", "@deciduous"],
    ["needleleaved", "@evergreen"],
    ["mixed", "#228B22"],
]);
ForestColors.Resolver = new ColorResolver(ForestColors.DefaultColor, ForestColors.ColorMap);
export class ForestOptions {
    constructor() {
        this.type = "mixed";
        this.color = ForestColors.DefaultColor;
    }
    static IsForest(record) {
        const tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        return tags.readValue("natural") === ForestOptions.woodKeywords || tags.readValue("landcover") === ForestOptions.treeKeywords;
    }
    static FromTags(record) {
        const tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        if (!this.IsForest(tags)) {
            return undefined;
        }
        const o = new ForestOptions();
        o.type = tags.readValue("leaf_cycle") ?? tags.readValue("leaf_type") ?? "mixed";
        o.color = ForestColors.Resolver.getColor(o.type);
        return o;
    }
}
ForestOptions.woodKeywords = "wood";
ForestOptions.treeKeywords = "trees";
//# sourceMappingURL=osm.interfaces.forest.js.map